import { HttpClient } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

export const TRANSLATION_HTTP_CLIENT = new InjectionToken<HttpClient>('Translation Http Client');
